module.exports = __webpack_public_path__ + "static/blackcliff-slasher-b823bde8304dce7a11435479a213cd05.png";